module.exports = __webpack_public_path__ + "img/ethereum-classic.0e4efda6.png";